import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { omit } from 'remeda';
import { BehaviorSubject, Observable } from 'rxjs';
import { LeaderboardPoolForAdmin } from 'src/app/types';
import { LeaderboardService } from '../../leaderboard.service';

@Component({
  animations: [
    trigger('fadeIn', [
      transition(':enter', [style({ opacity: '0' }), animate('.25s ease-out', style({ opacity: '1' }))]),
    ]),
  ],
  selector: 'lohi-leaderboards',
  templateUrl: './leaderboards.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeaderboardsComponent implements OnInit {
  public leaderboardPools$: Observable<LeaderboardPoolForAdmin[]>;
  public loadingForPool$: Observable<Record<string, boolean>>;
  public expandedLeaderboardPools$$ = new BehaviorSubject<Record<string, boolean>>({});

  constructor(private leaderboardService: LeaderboardService) {}

  public ngOnInit(): void {
    this.leaderboardPools$ = this.leaderboardService.leaderboardPools$.pipe();
    this.loadingForPool$ = this.leaderboardService.loadingForPool$;
  }

  public loadLeaderboard(poolId: number, leaderboardId: number) {
    if (!poolId || !leaderboardId) {
      return;
    }
    this.leaderboardService.loadLeaderboardForPool(poolId, leaderboardId);
  }

  public expandLeaderboardPool(id: number) {
    this.expandedLeaderboardPools$$.next({
      ...this.expandedLeaderboardPools$$.value,
      [`${id}`]: true,
    });
  }

  public collapseLeaderboardPool(id: number) {
    this.expandedLeaderboardPools$$.next(omit(this.expandedLeaderboardPools$$.value, [`${id}`]));
  }
}
